import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
	routes: [
	    {
	      path: '/',
	      component: resolve => require(['../components/Head.vue'], resolve),
		  children: [
		    {
		      path: '/',
		      component: resolve => require(['../components/Eco.vue'], resolve)
		    },
		    {
		      path: '/tickets',
		      component: resolve => require(['../components/Tickets.vue'], resolve)
		    }, {
		      path: '/about',
		      component: resolve => require(['../components/About.vue'], resolve)
		    }, {
		      path: '/owner',
		      component: resolve => require(['../components/Owner.vue'], resolve)
		    }
		  ]
	    },

	  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js